import {defineStore} from 'pinia'

export const FdicStore = defineStore('FdicStore', {
  state: () => ({
    showBanner: true,
    loadedTheFirstState: false,
    moveForward: () => {}
  }),
  actions: {
    reportMove() {
      if (this.loadedTheFirstState) {
        this.showBanner = false
      }
    }
  }
})
